/**
 * 
 */
class WMUWCBundleChildProduct {

	/**
	 * 
	 * @type HTMLElement
	 */
	element = null;

	/**
	 * 
	 * @type Number
	 */
	id = 0;

	/**
	 * 
	 * @type Number
	 */
	quantity = 1;

	/**
	 * 
	 * @type String
	 */
	type = 'simple';

	/**
	 * 
	 */
	constructor()
	{

	}

	/**
	 * 
	 */
	isValid()
	{
		return true;
	}

}

export default WMUWCBundleChildProduct;